import React, {Component, useEffect, useContext, useState } from 'react';
import axios from 'axios';
import ReactTable from 'react-table-v6';
import '../ReactTable.css';
import { useHistory } from "react-router-dom";
const queryString = require('query-string');



class Table extends Component
{
  constructor(props)
  {
    super(props);
    window.tutorTable = this;
    this.state = {
      tutors: [],
      
    }
    this.addTutorToState = this.addTutorToState.bind(this);
  }

  forceUpdateHandler(){
    console.log("forcing update");
    this.forceUpdate();
  };
  
  componentDidMount()
  {
    getTutors(this.props.classs);
  }

  addTutorToState(name,price,email)
  {
    console.log("running")
    var newItems= [this.state.tutors];
    newItems[0].push({name:name, price:price, email: email});
    this.setState({
      tutors: newItems[0]
    });
    
  }

  clearState()
  {
    this.setState({
      tutors: []
    });
    
  }


  
  render() {
    const columns = [
      {
        Header: "Name",
        accessor: "name"
      },
      {
        Header: "Price(Per Hour)",
        accessor: "price"
      },
      {
        Header: "Email",
        accessor: "email"
      },
      {
        Header: "View Profile",
        id: 'deleteRow',
        Cell: (row) => (<button style={{backgroundColor: 'white',color: 'black',cursor:'pointer',border: "none", borderRadius: "30px", height:"110%", width:"90%", fontSize: "25px"}} onClick={() => {
              let data = this.state.employees;
              const clickedEmail = this.state.tutors[row.index].email;
              console.log(clickedEmail);  
              var result = `?email=${clickedEmail}`; 
              this.props.hist.push({pathname: '/tutorProfile',search: result });
            }}>View Profile</button>)
      }
    ] 
    return (
      <div>
        <ReactTable ref={this.myRef} columns={columns} data={this.state.tutors} noDataText="No Tutors" href='./styles/ReactTable.css' />
      </div>
      
    );
  }
}











function getTutors(classSelection){
  window.tutorTable.clearState();
    var myParam = {
        class: classSelection
    }

    axios.post("https://auxilliabackend.herokuapp.com/getTutorInfo",myParam)
  .then(function (response) {
    
    const data = response.data;
    console.log("response:")
    console.log(data);

    for (var i = 0;i <  data.length;i++)
    {
      window.tutorTable.addTutorToState(data[i].Name,data[i].Price,data[i].Email);
    }


    //window.location.reload(true);
  })
  .catch(function (error) {
    console.log("SOMETHING WENT WRONG")
    console.log(error);
  });
}

class tutorTablePage extends React.Component{
  constructor(props)
  {
    super(props);
    
  }
  render()
  {
    const params = queryString.parse(window.location.search).class;
    console.log("POSTING");
    //var classSelection = "CSCE 315";
    return (
      <div className="App">
        <Table id='tutors' classs= {params}  hist={this.props.history} />         
        {/* <body className = "App-header">
          <div class = "loginbox">
            <img src = "logo192.png" class = "logo"></img>
            <h1>TESTING</h1>
            <input type="button" value="Click me" onClick={() => getTutors(classSelection)}></input>
          </div>
          <Table id='tutors'/>
        </body> */}
      </div>        
    );
  }


}

export default tutorTablePage;